export const CART_ADD_ITEM = 'CART_ADD_ITEM';
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM';
export const CART_REMOVE_ALL = 'CART_REMOVE_ALL';
export const CART_REMOVE_EXPIRED = 'CART_REMOVE_EXPIRED';
export const CART_UPDATE_QUANTITIES = 'CART_UPDATE_QUANTITIES';
export const CART_SET_USERDATA = 'CART_SET_USERDATA';
